// src/components/PremiumCanceled/index.jsx
import { useTheme, useMediaQuery } from "@mui/material";
import PremiumCanceledDesktop from "./PremiumCanceledDesktop";
import PremiumCanceledMobile from "./PremiumCanceledMobile";

export default function PremiumCanceled() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return isMobile ? <PremiumCanceledMobile /> : <PremiumCanceledDesktop />;
}
